// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import { useFormatCoin, CoinFormat, formatBalance } from '@mysten/core';
import { Text } from '@mysten/ui';

import { DGC_TYPE_ARG } from '~/utils/cpcCoin';

type StakeColumnProps = {
	stake: bigint | number | string;
	hideCoinSymbol?: boolean;
	inMIST?: boolean;
	/** Dark page backgrounds (stake hub, modals). */
	onDark?: boolean;
};

export function StakeColumn({ stake, hideCoinSymbol, inMIST = false, onDark }: StakeColumnProps) {
	const coinFormat = hideCoinSymbol ? CoinFormat.FULL : CoinFormat.ROUNDED;
	const [amount, symbol] = useFormatCoin(stake, DGC_TYPE_ARG, coinFormat);
	const textColor = onDark ? 'white' : 'dark';
	const subColor = onDark ? 'dark' : 'dark';
	return (
		<div className="inline-flex items-center gap-0.5">
			<Text variant="bodySmall/medium" color={textColor}>
				{inMIST ? formatBalance(stake, 0, coinFormat) : amount}
			</Text>
			{!hideCoinSymbol && (
				<Text variant="captionSmall/medium" color={subColor}>
					{inMIST ? 'MIST' : symbol}
				</Text>
			)}
		</div>
	);
}
